import api from '@/api';
import { CompanySintegraDTO, CompanySintegraGenerate } from './Sintegra.types';
import { API_BASE_URL } from '.';

const CONTROLLER_URL = `${API_BASE_URL}/sintegra`;

export async function companySintegraCreate(data: CompanySintegraDTO) {
  const result = (await api.post(
    `${CONTROLLER_URL}/settings`,
    data,
    null,
  )) as unknown;
  return result as CompanySintegraDTO;
}

export async function companySintegraGenerate(data: CompanySintegraGenerate) {
  const result = (await api.post(
    `${CONTROLLER_URL}/generate`,
    data,
    null,
  )) as unknown;
  return result as string;
}

export async function getCompanySintegra(companyId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/settings/${companyId}`,
    null,
  )) as unknown;
  return result as CompanySintegraDTO;
}

export async function companySintegraEdit(data: CompanySintegraDTO) {
  const result = (await api.put(
    `${CONTROLLER_URL}/settings/${data.companyId}`,
    data,
    null,
  )) as unknown;
  return result as CompanySintegraDTO;
}
